module.exports = __webpack_public_path__ + "img/second_place.c417e39b.png";